import { PaymentCheckout } from "modulos/outros/checkout/components/payment-checkout"
import React, { useCallback, useMemo, useState } from "react"
import { InformarCartaoProps } from "./informar-cartao-props"
import { PessoaModel } from "api/cardapio/models/pessoa/pessoa-model"
import { ResponsePaymentDataProps } from "modulos/outros/checkout/components/payment-checkout-props"
import { Box, Button, Fade, Grid, Typography } from "@material-ui/core"
import { FasesHeader } from "../../../components/fases-header/fases-header"
import { CartaoIcon } from "components/icons/cartao-icon"
import { Carregando, useNotificacoes } from "components"
import { useStyles } from "./informar-cartao-styles"
import { EfetuarPedidoPagamentoModel, TipoStatusPagamentoEnum } from "api/cardapio/models/pedido/efetuar-pedido"
import { CredenciamentoModel } from "api/cardapio/models/finalizadora/finalizadora-model"
import { EnumPaymentType } from "api/checkout/models"
import { removerMascaraDocumento } from "utils/cpfcnpj-format"
import { usePedidos } from "services/providers/pedidos-provider"

export const InformarCartao = ({ clickFinalizar, onClickVoltar }: InformarCartaoProps) => {

    const [loading, setLoading] = useState<boolean>(false)
    const classes = useStyles()
    const { getCliente, carregandoCriarPedido, transacao: transacaoSelecionada, getItensSacola, setTransacao, finalizadoraSelecionada } = usePedidos()
    const itensSacola = getItensSacola()
    const valor = (itensSacola ?? []).reduce((prev, curr) => prev + curr.vProd, 0)
    const carregando = carregandoCriarPedido || loading
    const { showErrorMessage } = useNotificacoes()
    const [error, setError] = useState<string>()

    const getCredenciais = useMemo(() => {
        if (!finalizadoraSelecionada) return new CredenciamentoModel()
        const credenciais = JSON.parse(finalizadoraSelecionada.credenciais)
        return credenciais as CredenciamentoModel
    }, [finalizadoraSelecionada])

    const responsePayment = useCallback(async (data: ResponsePaymentDataProps) => {
        try {
            if (data.success) {
                if (data.data) {
                    const charge = data.data.charge
                    const transacao = charge.transactions[0]
                    if (!transacaoSelecionada) throw new Error('Transação inválida.')

                    if (charge.chargeStatus === 'NotAuthorized') {
                        throw new Error('Pagamento não autorizado. Verifique se o cartão tem limite disponível ou está desbloqueado para transações, e tente novamente para concluir seu pedido.')
                    }

                    const card = transacao.card
                    const payment: EfetuarPedidoPagamentoModel = {
                        ...transacaoSelecionada,
                        nomeCartao: card.cardholderName,
                        bandeira: card.brandName,
                        concluido: true,
                        mensagem: 'Pagamento Crédito',
                        nroCartao: card.cardNumber,
                        status: TipoStatusPagamentoEnum.Confirmado,
                        nsu: charge.nsu,
                        cAut: transacao.authorizationCode,
                        tefId: transacao.transactionId ?? '',
                    }
                    setTransacao(payment)
                    clickFinalizar()
                }
            } else {
                showErrorMessage(data.messageError ?? 'Ocorreu um erro ao realizar o pagamento, verifique os dados do cartão e tente novamente.')
            }
        } catch (err: any) {
            showErrorMessage(err.message)
        }
    }, [clickFinalizar, setTransacao, showErrorMessage, transacaoSelecionada])

    const handleLoading = (value: boolean) => setLoading(value)

    return (
        <Fade in={true}>
            <Box display="flex" flexDirection="column" height="100%">
                <FasesHeader titulo="INFORMAR CARTÃO" icon={CartaoIcon} voltar={onClickVoltar} />
                <Box className={classes.content}>
                    {error ? (
                        <Grid container justify="center" alignItems="center" className={classes.container}>
                            <Box gridGap={16} display="flex" textAlign="center" flexDirection="column">
                                <Typography variant="h4">
                                    <Box fontWeight={700}>
                                        Ocorreu um problema
                                    </Box>
                                </Typography>
                                <Typography variant="body1">
                                    {error}
                                </Typography>
                                <Button variant="outlined" onClick={() => setError(undefined)} size="large">
                                    Tentar Novamente
                                </Button>
                            </Box>
                        </Grid>
                    ) : (
                        <>
                            <Carregando
                                titulo={'Processando pagamento...'}
                                mensagem={"Finalizando o pagamento para concluir seu pedido. Só mais um momento."}
                                modelo="absolute"
                                carregando={carregando}
                            />
                            <Grid container justify="center" alignItems="center" className={classes.container}>
                                <PaymentCheckout
                                    amount={valor}
                                    cliente={getCliente() ?? new PessoaModel()}
                                    merchantCredenciais={{
                                        merchantCredential: removerMascaraDocumento(getCredenciais.cnpj),
                                        merchantId: getCredenciais.merchantId,
                                        merchantToken: getCredenciais.merchantToken,
                                    }}
                                    paymentType={EnumPaymentType.Credito}
                                    responsePayment={responsePayment}
                                    setLoading={handleLoading}
                                />
                            </Grid>
                        </>
                    )}
                </Box>
            </Box>
        </Fade>
    )
}